import { createContext, ReactNode, useState } from "react";

interface TranslationsContextProps {
  translations: { [key: string]: string };
  setTranslations: (translations: { [key: string]: string }) => void;
  setLanguage: (language: string) => void;
  language: string;
}

const defaultContext: TranslationsContextProps = {
  translations: { "airports.title": "Welcome" },
  setTranslations: () => {},
  setLanguage: () => {},
  language: "de",
};

export const TranslationsContext =
  createContext<TranslationsContextProps>(defaultContext);

export const TranslationsProvider = ({
  children,
  initialTranslations,
}: {
  children: ReactNode;
  initialTranslations: { [key: string]: string };
}) => {
  const [translations, setTranslations] = useState(initialTranslations);
  const [language, setLanguage] = useState(defaultContext.language);

  return (
    <TranslationsContext.Provider
      value={{ translations, setTranslations, setLanguage, language }}
    >
      {children}
    </TranslationsContext.Provider>
  );
};
